import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { useDispatch } from 'react-redux';
import { EModePanelSelect } from './SelectPanel';
import { IOptionData } from 'models/OptionData';
import {
  updateSelectMultipleCategory,
  updateSelectMultipleCustomer,
  updateSelectMultipleOrder,
  updateSelectMultipleStaff,
  updateSelectMultipleStock
} from '@slice/select.slice';
import styled from 'styled-components';

export const SelectStyle: any = styled(Select)`
  &.ant-select .ant-select-selector {
    white-space: nowrap !important;
    max-width: 270px;
    min-width: 170px;
    height: 32px;
  }
`;

interface IMultipleSelect {
  options: Array<IOptionData>;
  value?: Array<IOptionData>;
  type?: EModePanelSelect;
  initial?: Array<string>;
  onChange?: (value: Array<IOptionData>) => void;
}

const MultipleSelect = React.memo((props: IMultipleSelect) => {
  const dispatch = useDispatch();
  const [listSelected, setListSelected] = useState<Array<IOptionData> | undefined>(undefined);

  const options = useMemo(() => {
    return props.options.map((item, index) => (
      <Select.Option label={item.label} value={item.value} key={index}>
        {item.label}
      </Select.Option>
    ));
  }, [props.options]);

  const onChangeValueSelect = (data: string[]) => {
    const optionValue: Array<IOptionData> = [];
    if (data.includes('-1') && data.length + 1 === props.options.length) {
      data.shift();
      for (const i in data) {
        const tempList = props.options.find(item => item.value === data[i]);
        tempList && optionValue.push(tempList);
      }
      setListSelected(optionValue);
      return 0;
    }
    if (data.includes('-1')) {
      setListSelected([props.options[0]]);
      return 0;
    }

    if (data.length === 0) {
      setListSelected([]);
      return 0;
    }

    for (const i in data) {
      const tempList = props.options.find(item => item.value === data[i]);
      tempList && optionValue.push(tempList);
    }
    setListSelected(optionValue);

    // Kiểm tra xem props.onChange có tồn tại và gọi nó
    props.onChange && props.onChange(optionValue);
  };

  useEffect(() => {
    if (
      (props.type === EModePanelSelect.Staff ||
        props.type === EModePanelSelect.Sell ||
        props.type === EModePanelSelect.Tech) &&
      listSelected
    ) {
      dispatch(updateSelectMultipleStaff(listSelected));
    } else if (props.type === EModePanelSelect.Stock && listSelected) {
      dispatch(updateSelectMultipleStock(listSelected));
    } else if (props.type === EModePanelSelect.Customer && listSelected) {
      dispatch(updateSelectMultipleCustomer(listSelected));
    } else if (props.type === EModePanelSelect.Category && listSelected) {
      dispatch(updateSelectMultipleCategory(listSelected));
    } else if (props.type === EModePanelSelect.Order && listSelected) {
      dispatch(updateSelectMultipleOrder(listSelected));
    }
  }, [listSelected]);

  const valueSelect = useMemo(() => {
    if (props.value && props.value.length !== 0) {
      if (props.value[0]!.value === '-1') {
        return props.options;
      }
      // cần thêm display khi hơn 2 selected
      if (props.value.length > 0) {
        return props.value;
      }
    }
    return props.value;
  }, [props.value]);

  return (
    <SelectStyle
      mode={'multiple'}
      showSearch
      allowClear
      placeholder={props.initial}
      onChange={onChangeValueSelect}
      value={valueSelect && valueSelect}
    >
      {options}
    </SelectStyle>
  );
});

MultipleSelect.displayName = 'MultipleSelect';

export default MultipleSelect;
